











import {Component, Prop, Vue} from 'vue-property-decorator'
import {Highlight} from '../lib/kepler/interfaces'

@Component({
  components: {},
  name: 'HorizontalHighlight',
})
export default class HorizontalHighlight extends Vue {
  @Prop() public highlights!: Highlight[]
  @Prop() public titleColor!: string

  get highlightWidth() {
    const width = 100 / this.highlights.length
    return `width:${width}%`
  }
}
